/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_When_OverlineInputs */

const en_cmp_when_overline = /** @type {(inputs: Cmp_When_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Honest answer`)
};

const id_cmp_when_overline = /** @type {(inputs: Cmp_When_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jawaban jujur`)
};

/**
* | output |
* | --- |
* | "Honest answer" |
*
* @param {Cmp_When_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_when_overline = /** @type {((inputs?: Cmp_When_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_When_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_when_overline(inputs)
	return en_cmp_when_overline(inputs)
});